if (!customElements.get('testimonials-slider')) {
  class TestimonialsSlider extends HTMLElement {
    constructor() {
      super();
      this.options = {
        slidesPerView: 1,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: `.swiper-pagination--${this.dataset.sectionId}`,
          type: 'fraction',
          clickable: true,
        },
      };
    }

    connectedCallback() {
      const element = this.querySelector('[data-slider]');

      if (!element || !Swiper) return;

      this.slider = new Swiper(element, this.options);
    }
  }

  customElements.define('testimonials-slider', TestimonialsSlider);
}
